<template>
  <div
    class="reacquire flex justify-center blocks cursor-pointer"
    :style="{ lineHeight }"
    @click="getData"
  >
    <span>重新获取</span>
  </div>
</template>

<script setup lang="ts">
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
withDefaults(
  defineProps<{
    lineHeight?: string
  }>(),
  {
    lineHeight: '200px',
  },
)

const emit = defineEmits<{
  onclick: [e: MouseEvent]
}>()

const getData = (e: MouseEvent) => {
  emit('onclick', e)
}
</script>

<style lang="scss" scoped>
.reacquire {
  user-select: none;
  color: rgb(168, 168, 168);
  span:hover {
    color: var(--prev-color-primary, #1890ff);
    text-decoration: underline;
  }
}

.blocks {
  width: 100%;
  height: 100%;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
